
export const HBNS_APP_ID = process.env.REACT_APP_HBNS_APP_ID
export const HBNS_PROJECTS = [ process.env.REACT_APP_HBNS_PROJECT ]
export const PROJECT_ID=process.env.REACT_APP_HBNS_PROJECT

export const TOKEN_GEN_ENDPOINT =`${process.env.REACT_APP_AUTH_URI}/jwt/basicauth`   
export const TOKEN_REFRESH_ENDPOINT=`${process.env.REACT_APP_AUTH_URI}/jwt/refresh`   
export const TOKEN_REVOKE_ENDPOINT=`${process.env.REACT_APP_AUTH_URI}/jwt/revoke`   
export const CONFIG_SERVER_ENDPOINT=process.env.REACT_APP_CONFIG_SERVER_ENDPOINT
export const CONFIG_SERVER_APIKEY=process.env.REACT_APP_CONFIG_SERVER_APIKEY

export const PROJECT_UPLOAD_URI=`${process.env.REACT_APP_PROJECTS_URI}/projects` 
export const PROJECT_DOCS_URI=`${process.env.REACT_APP_PROJECTS_URI}/content` 
export const PROJECT_FILES_URI=`${process.env.REACT_APP_PROJECTS_URI}/storage` 
export const CDN_URI=`${process.env.REACT_APP_PROJECTS_URI}/cdn` 

export const TOKEN_AUDIENCE =  JSON.parse(process.env.REACT_APP_AUD)